import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Hero2 from "../../components/hero2/hero2";
import WeddingDate from "../../components/WeddingDate/WeddingDate";
import CoupleSection2 from "../../components/CoupleSection2/CoupleSection2";
import StorySection2 from "../../components/StorySection2/StorySection2";
import PortfolioSectionS2 from "../../components/PortfolioSectionS2/PortfolioSectionS2";
import RsvpSectionS2 from "../../components/RsvpSectionS2/RsvpSectionS2";
import EventSection from "../../components/EventSection/EventSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";

interface HomePage2Props {
  hclass?: string;
}

const HomePage2: React.FC<HomePage2Props> = () => {
  return (
    <Fragment>
      <Navbar hclass="header-style-s2" />
      <Hero2 />
      <WeddingDate />
      <CoupleSection2 />
      <StorySection2 />
      <PortfolioSectionS2 />
      <RsvpSectionS2 />
      <EventSection /> 
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default HomePage2;
